<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.taskView')" style="margin-top: -14px">
        <PackingTaskTable ref="table" :device="device" :positionTypeId="positionTypeId" :positions="positions" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.internalReview')" forceRender style="margin-top: -14px">
        <PackingTaskDetail ref="detail" :auto-review="autoReview" :device="device" :entire="entire" :positionTypeId="positionTypeId" :positions="positions"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button v-if="activeKey==='1'" type="primary" @click="refresh">{{$t('button.refresh')}}</a-button>
        <a-button v-if="activeKey==='2'" type="primary" @click="sealing">{{$t('button.sealing')}}</a-button>
        <a-button v-if="activeKey==='2' && !autoReview" type="primary" @click="confirm">{{$t('button.review')}}</a-button>
        <a-button v-if="activeKey==='2'" type="primary" @click="split">{{$t('button.split')}}</a-button>
        <a-button v-if="activeKey==='2'" type="primary" @click="save">{{$t('button.shortPicking')}}</a-button>
        <a-button type="primary" @click="reset">{{$t('button.empty')}}</a-button>
        <a-button v-if="activeKey==='2'" type="primary" @click="rePrint">{{$t('button.rePrint')}}</a-button>
        <a-button type="primary" @click="printAfterConfirm">{{$t('button.printAfterConfirm')}}</a-button>
        <a-button v-if="activeKey==='2'" type="primary" @click="supervise">{{$t('button.scanSupervisorCode')}}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
import PackingTaskDetail from '@/views/outbound/pack_template/PackingTaskDetail.vue'
import PackingTaskTable from '@/views/outbound/pack_template/PackingTaskTable.vue'
import { findAll } from '@/api/Api'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'

export default {
  name: 'Packing',
  components: { SupervisedModal, PackingTaskTable, PackingTaskDetail },
  props: {
    queryParam: { type: Object, default: null },
    device: { type: Boolean, default: false }
  },
  data() {
    return {
      activeKey: '1',
      autoReview: this.queryParam.value.business.autoReview,
      entire: this.queryParam.value.business.entire,
      positionTypeId: this.queryParam.value.business.positionTypeId,
      positions: []
    }
  },
  watch: {
    activeKey() {
      if (this.activeKey === '1') {
        this.refresh()
      }
    }
  },
  mounted() {
    if (this.positionTypeId !== null && this.positionTypeId !== undefined) {
      findAll('locationFactory', { 'positionType.id': this.positionTypeId }).then(res => {
        if (res.success) {
          this.positions = res.result
        }
      })
    }
  },
  methods: {
    sealing() {
      this.$refs.detail.sealing()
    },
    confirm() {
      this.$refs.detail.confirm()
    },
    split() {
      this.$refs.detail.split()
    },
    save() {
      this.$refs.detail.save()
    },
    reset() {
      if (this.activeKey === '1') {
        this.$refs.table.reset()
      } else {
        this.$refs.detail.reset()
      }
    },
    rePrint() {

    },
    printAfterConfirm() {
      this.$refs.detail.openShipmentBarcodeModal()
    },
    supervise() {
      this.$refs.detail.openSupervisedModal()
    },
    dblclick(row) {
      this.activeKey = '2'
      this.$refs.detail.position = row.position === null ? this.$refs.table.position : row.position
      if (this.device) {
        this.$refs.detail.container = row.container
      } else {
        this.$refs.detail.pickingOrder = row.pickingOrder
      }
      this.$refs.detail.obtain()
    },
    refresh() {
      this.$refs.table.refresh()
    }
  }
}
</script>